import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import type { BrandLogoProps } from './BrandLogoProps';
import { getAppTitle } from '../getAppTitle';

const StyledBrandLogo = styled.img<{ isBackground?: boolean; opacity?: number; topOffset?: number }>`
  display: inline-block;
  ${({ isBackground, opacity, topOffset }) =>
    isBackground
      ? ` opacity: 0.1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: ${topOffset ?? 70}px;
  pointer-events: none;`
      : ` opacity: ${opacity};`}
`;

export const BrandLogo = ({
  className,
  isBackground,
  opacity,
  showText,
  height,
  isDark,
  topOffset,
}: BrandLogoProps) => {
  const { Images } = useContext(ThemeContext);
  const appTitle = getAppTitle();

  const logoHeight = height || (showText ? 47 : 30);

  if (showText) {
    return <img src={Images.vennProvidedLogo} alt={`${appTitle} logo`} height={logoHeight} />;
  }

  return (
    <StyledBrandLogo
      src={isDark ? Images.brandLogoDark : Images.brandLogo}
      className={className}
      alt={`${appTitle} logo`}
      height={logoHeight}
      width={logoHeight}
      isBackground={isBackground}
      opacity={opacity}
      topOffset={topOffset}
    />
  );
};

export default BrandLogo;
